<script>
    // Primeira parte: Conversor km/h <-> Pace
    let velocidade = "";
    let pace = "";

    function converterKmParaPace() {
        if (velocidade) {
            // Converte km/h para min/km (Pace)
            let minutosPorKm = 60 / parseFloat(velocidade);
            let minutos = Math.floor(minutosPorKm);
            let segundos = Math.round((minutosPorKm - minutos) * 60);
            pace = `${minutos.toString().padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`;
            console.log(pace);
        }
    }

    function converterPaceParaKm() {
        if (pace) {
            // Converte min/km para km/h
            let [minutos, segundos] = pace.split(":").map(Number);
            let minutosTotal = minutos + segundos / 60;
            velocidade = (60 / minutosTotal).toFixed(2);
        }
    }

    // Segunda parte: Calculadora de Distância e Tempo
    let distancia = "";
    let tempo = "";
    let resultadoPace = "";
    let resultadoVelocidade = "";

    function calcular() {
        let [horas, minutos, segundos] = tempo.split(":").map(Number);
        let tempoHoras = horas + minutos / 60 + segundos / 3600;

        // Calcula o pace (min/km) e a velocidade (km/h)
        let paceMinPorKm = ((horas * 60) + minutos + segundos / 60) / distancia;
        let minutosPace = Math.floor(paceMinPorKm);
        let segundosPace = Math.round((paceMinPorKm - minutosPace) * 60);

        resultadoPace = `${minutosPace}:${segundosPace.toString().padStart(2, "0")}`;
        resultadoVelocidade = (distancia / tempoHoras).toFixed(2);
    }
</script>
<div class="back">


<br />
<br />
<div class="container">
    <h2 class="text-center m-4">Conversor de Pace e km/h</h2>

    <!-- Primeira parte: Conversor km/h <-> Pace -->
    <div class="card p-4 shadow-sm">
        <div class="mb-3">
            <label for="velocidade" class="form-label">Velocidade (km/h):</label>
            <input
                id="velocidade"
                type="number"
                bind:value={velocidade}
                class="form-control"
                placeholder="Ex: 12"
            />
        </div>

        <div class="mb-3">
            <label for="pace" class="form-label">Pace (min/km):</label>
            <input
                id="pace"
                type="time"
                bind:value={pace}
                class="form-control"
                placeholder="Ex: 5:00"
            />
        </div>

        <div class="d-grid gap-2 d-md-block text-center">
            {#if velocidade}
                <button on:click={converterKmParaPace} class="btn btn-primary"
                    >Converter km/h para Pace</button
                >
            {/if}
            {#if pace}
                <button on:click={converterPaceParaKm} class="btn btn-secondary"
                    >Converter Pace para km/h</button
                >
            {/if}
        </div>
    </div>

    <!-- Segunda parte: Calculadora de Distância e Tempo -->
    <h2 class="text-center mb-4">Calculadora de Pace e Velocidade</h2>

    <div class="card p-4 shadow-sm">
        <div class="mb-3">
            <label for="distancia" class="form-label">Distância (km):</label>
            <input
                id="distancia"
                type="number"
                bind:value={distancia}
                class="form-control"
                placeholder="Ex: 10"
            />
        </div>

        <div class="mb-3">
            <label for="tempo" class="form-label">Tempo (hh:mm:ss):</label>
            <input
                id="tempo"
                type="time"
                bind:value={tempo}
                class="form-control"
                placeholder="Ex: 01:30:00"
                step="1"
            />
        </div>
        {#if tempo && distancia}
            <button on:click={calcular} class="btn btn-secondary w-100"
                >Calcular</button
            >
        {/if}
        {#if resultadoPace && resultadoVelocidade}
            <div class="resultado mt-4">
                <div class="alert alert-success">
                    <strong>Pace:</strong>
                    {resultadoPace} min/km<br />
                    <strong>Velocidade:</strong>
                    {resultadoVelocidade} km/h
                </div>
            </div>
        {/if}
    </div>
</div>
<br />
<br />
<br />
<br /><br />
<br /><br />
<br /><br />
<br />
</div>
<style>
    .container {
        max-width: 600px;
        margin: 0 auto;
        padding: 20px;
       color:white;
    }
    .card {
        margin-bottom: 20px;
    }
    .back{
         background-image: url("/img/calculadora1.jpg");
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
   overflow-y: auto;
   
   }
</style>
